// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RouteNav_wrapper__3ur81","backButton":"RouteNav_backButton__1d68e","forwardButton":"RouteNav_forwardButton__2sDZE"};